import { useQuery } from '@tanstack/react-query';
import { parkingVehicleOptions } from '../../constants/parkingVehicles';
export function useParkingVehicles(filter) {
    const { data, isLoading } = useQuery(parkingVehicleOptions.get(filter));
    return {
        parkingVehicles: data ?? [],
        loadingParkingVehicles: isLoading,
    };
}
